export default __webpack_public_path__ + "static/media/decor12.57147608.webp";